import { RootState } from 'store/rootTypes';

export const EmployeeSelector = (state: RootState) => state.Employee;
